import { styled } from '@mui/material';
import { Policy } from './Policy';

export const FooterStyled = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 12px;
`;

export const PolicyStyled = styled(Policy)`
  width: 100%;
  max-width: 330px;
  font-size: 12px;
  line-height: 140%;
  color: ${(props) => props.theme.palette.text.primary};

  a {
    text-decoration: underline;
  }
`;
